// Analyze "frontier" — which tool the advisor's Next step is promoting.
//
// The Analyze overview's Next-step card, its artifact cards and the rail
// nest's ➤ all derive from ONE source: the advisor's top analyze-phase rec
// (useAnalyzeRecs). A second headline engine (pickHeadlineCta) used to drive
// the card hiding and the ➤ while the Next-step card followed the advisor; the
// two disagreed live (2026-09-24: audit card hidden + ➤ on audit while the
// card said "Ask your corpus"), so the headline engine was retired.
import type { ToolId } from "@/lib/analyzeToolState";
import type { WorkflowRecommendation } from "@/lib/workflowAdvisor";

const REC_TOOL: Record<string, ToolId> = {
  field_debate: "field-debate",
  refresh_debate: "field-debate",
  drill: "field-debate",
  audit: "coverage-audit",
  chat: "chat",
};

/** The tool the top analyze rec points at, or null (non-tool / no rec). */
export function analyzeFrontierTool(
  rec: WorkflowRecommendation | undefined,
): ToolId | null {
  return (rec && REC_TOOL[rec.id]) ?? null;
}

/**
 * Whether an overview artifact card is redundant with the Next-step card.
 * Only the first-run promotions ("Run Field Debate" / "Run the coverage
 * audit") hide their card — the Next-step card IS that tool's entry point.
 * Once a tool has output (drill, chat), its card stays: it carries state.
 */
export function shouldHideFromRail(
  toolId: string,
  rec: WorkflowRecommendation | undefined,
): boolean {
  if (!rec) return false;
  if (rec.id === "field_debate" && toolId === "field-debate") return true;
  if (rec.id === "audit" && toolId === "coverage-audit") return true;
  return false;
}

/**
 * Whether the advisor should recommend refreshing the debate: stale AND
 * nothing already in flight to fix it — never re-recommend a refresh/build
 * the user already started (Codex review 2026-09-24, round 3).
 */
export function needsDebateRefresh(
  stale: boolean,
  running: boolean,
  refreshing: boolean,
): boolean {
  return stale && !running && !refreshing;
}
